(function () {
    'use strict';

    angular
        .module('app.tenants')
        .controller('TenantDetailsController', TenantDetailsController);

    TenantDetailsController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function TenantDetailsController($state, $stateParams,
        bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        vm.cancel = cancel;
        vm.isSaving = false;
        vm.save = save;
        vm.filters = undefined;
        vm.isNew = isNew;
        vm.openDatePicker = openDatePicker;
        vm.opsIncludeVersion = common.opsIncludeVersion;
        vm.dpStatus = {
            displayOnOpen: false,
        }
        vm.showPassword = showPassword;

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItem(), initLookups()];
            return common.$q.all(promises).then(function (data) {
                
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function openDatePicker($event) {
            vm.dpStatus.displayOnOpen = true;
        }

        function backToList() {
            $state.go("tenants.list");
        }

       
        function isNew() {
            var val = $stateParams.id; 
            return val === "-1";
        }


        function getItem() {
            var val = $stateParams.id;
            if (val === '-1') {
                vm.item = {};
                vm.item.Active = 1;
                vm.item.ShowTerms = 1;
                vm.item.HasOps = 1;
                vm.item.SingleSignOn = 0;
                
                return vm.item;
            }

            return dataservice.getItem("api/Tenants/" + val)
                .then(function (data) {
                    vm.item = data.data;
                    vm.item.ActiveUntilUtc = moment(vm.item.ActiveUntilUtc).toDate();
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }

        function initLookups() {
            dataservice.getItems("api/Tenants/Timezones").then(function (data) {
                vm.timezones = data.data;
            }, function (error) { });

            dataservice.getItems("api/Tenants/ApiTypes").then(function (data) {
                vm.ApiTypes = data.data;
            }, function (error) { });

        }

        function showPassword() {
            return true;
        }

        function save() {
            vm.isSaving = true;
            if (isNew()) {
                vm.item.ID = -1;
            }
            dataservice.saveItem('api/Tenants', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
    }
})();
